<template>
  <div>
    <el-form ref="form" label-width="90px" class="demo-dynamic">
      <!-- 跳转链接的配置项开始 -->
      <div class="ovf-auto" style="max-height:600px">
        <div v-for="(option, index) in selfHandle" class="bor-b-ccc m-b-10">
          <el-form-item label="操作名称">
            <el-input v-model="option.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="按钮颜色">
            <el-select v-model="option.btn_color">
              <el-option 
                v-for="item in btnColors"
                :value="item.id"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="背景颜色">
            <el-select v-model="option.font_color">
              <el-option 
                v-for="item in fontColors"
                :value="item.id"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作方式">
            <el-radio-group v-model="option.deal_type">
              <el-radio :label="10">打开外链新页面</el-radio>
              <el-radio :label="20">弹窗跳转功能集</el-radio>
              <el-radio :label="30">页面跳转功能集</el-radio>
            </el-radio-group>
            <div class="form-tips">注：【弹窗跳转功能集】不支持跳转到有弹窗的功能集</div>
          </el-form-item>
          <div v-if="option.deal_type != SELFHANDLE_LINK">
            <el-form-item label="参数">
              <el-select v-model="option.param" filterable placeholder="请选择字段">
                <el-option
                  v-for="item in fields"
                  :label="item.field"
                  :value="item.field">
                  <span>{{ item.field }}（{{ item.title }}）</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实例">
              <el-input v-model="option.reality.name" class="w-180" :disabled="true" @change="realityChange(option)"></el-input>
              <el-button @click.prevent="openRealityDialog(option)">查找实例</el-button>
            </el-form-item>
            <el-form-item label="关联字段">
              <el-select filterable  v-model="option.fields" v-loading="loading" multiple placeholder="请选择">
                <template v-if="option.reality.id && fieldsByModelId[option.reality.id]">
                  <el-option
                    v-for="item in fieldsByModelId[option.reality.id]"
                    :label="item.field + item.title"
                    :value="item.field">
                    <span>{{ item.field }}（{{ item.title }}）</span>
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="外链url">
              <el-input v-model="option.url"></el-input>
            </el-form-item>
            <el-form-item label="绑定权限规则">
              <el-input v-model="option.rule.name" class="w-180" :disabled="true"></el-input>
              <el-button size="small" @click.prevent="openRuleDialog(option)">查找</el-button>
              <el-button size="small" @click="clearRule(option)">清空</el-button>
            </el-form-item>
          </div>
          <el-form-item label="可用条件" prop="has_condition">
            <el-radio-group v-model="option.has_condition">
              <el-radio :label="0">无限制</el-radio>
              <el-radio :label="1">条件限制</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="showCondition(option)">
            <el-select filterable v-model="option.condition.field_id" placeholder="字段名" class="fl w-150 m-r-10 m-b-10">
              <el-option v-for="item in fields" :label="item.field + '(' + item.title + ')'" :value="item.field_id"></el-option>
            </el-select>
            <el-select v-model="option.condition.logic" placeholder="计算公式" class="fl w-150 m-r-10 m-b-10">
              <el-option v-for="item in logicTypes" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-input v-model="option.condition.value" placeholder="值" class="fl w-150 m-r-10 m-b-10"></el-input>
            <el-select v-model="option.condition.auth" placeholder="对应情况" class="fl w-150 m-r-10 m-b-10">
              <el-option v-for="item in authTypes" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <div class="m-b-10">
            <el-button @click="sortUp(index)" :disabled="index == 0">上移</el-button>
            <el-button @click="sortDown(index)" :disabled="index == selfHandle.length - 1">下移</el-button>
            <el-button @click="deleteSelfHandle(index)">删除</el-button>
          </div>
        </div>
      </div>
      <div>
        <el-button type="primary" @click="addSelfHandle">增加一个</el-button>
      </div>
    </el-form>
    <rule-list ref="ruleList" @selectRule="selectRule"></rule-list>
    <reality-list ref="realityList" @selectReality="selectReality" :title="title"></reality-list>
  </div>
</template>

<script>
  import ruleList from '../../Common/business/rule.vue'
  import realityList from './reality.vue'
  import http from '../../../assets/js/http'
  import cmsConfig from '../../../config/cmsConfig'

  export default {
    name: 'selfHandleConfig',
    props: {
      selfHandle: {
        type: Array,
        default() {
          return []
        }
      },
      fields: {
        type: Array,
        defalut() {
          return []
        }
      }
    },
    data() {
      return {
        fontColors: [
          { id: '#ffffff', name: '白色' },
          { id: '#000000', name: '黑色' }
        ],
        btnColors: [
          { id: '#36a9fe', name: '蓝色' },
          { id: '#0ec233', name: '绿色' }
        ],
        listChange: false,
        beChange: false,
        loading: false,
        fieldsByModelId: {},
        selfHandleModel: {
          name: '',
          font_color: '',
          btn_color: '',
          deal_type: 10,
          param: '',
          reality: {
            id: '',
            name: ''
          },
          fields: [],
          rule: {
            id: '',
            name: ''
          },
          url: '',
          iden: '',
          has_condition: 0,
          condition: {
            field_id: '',
            logic: '',
            value: '',
            auth: ''
          }
        },
        authTypes: [  // 按钮权限类型
          { id: 10, name: '不可见' },
          { id: 20, name: '禁用' }
        ],
        logicTypes: [ // 逻辑数组
          { id: '=', name: '等于' },
          { id: '!=', name: '不等于' },
          { id: '>', name: '大于' },
          { id: '<', name: '小于' },
          { id: '<=', name: '小于等于' },
          { id: '>=', name: '大于等于' }
        ],
        currentHandle: {},
        existIden: [],
        currendIden: 1
      }
    },
    methods: {
      showCondition(item) {
        return item.has_condition == 1
      },
      async getFields(id) {
        let arr = []
        let res = await this.apiGet(`cms/deals/all_fields/${id}`)
        return this.promiseHandler(arr, res)
      },
      async getFieldOption(model_id) {
        let arr = []
        this.summaryLoading = true
        let res = await this.apiGet(`cms/deals/fields/${model_id}`)
        this.summaryLoading = false
        return this.promiseHandler(arr, res)
      },
      openRuleDialog(item) {
        this.currentHandle = item
        this.$refs.ruleList.open()
      },
      clearRule(item) {
        item.rule.name = ''
        item.rule.id = null
      },
      openRealityDialog(item) {
        this.currentHandle = item
        this.$refs.realityList.open()
      },
      selectRule(id, title_else, title) { // 选择权限
        this.currentHandle.rule.id = id
        this.currentHandle.rule.name = title_else
      },
      selectReality(id, name) {
        this.currentHandle.reality.id = id
        this.currentHandle.reality.name = name
        this.realityChange(this.currentHandle)
      },
      switchList() {
        this.listChange = true
        setTimeout(() => {
          this.listChange = false
        }, 1000)
      },
      async realityChange(item) {
        if (this.beChange || this.listChange) {
          return
        }
        item.fields = []
        this.loading = true
        let fields = await this.getFields(item.reality.id)
        this.$set(this.fieldsByModelId, item.reality.id, fields)
        this.loading = false
      },
      conditionChange(item) {
        if (this.beChange || this.listChange) {
          return
        }
        if (!this.showCondition(item)) {
          this.condition = {
            field_id: '',
            logic: '',
            value: '',
            auth: ''
          }
        }
      },
      addSelfHandle() {
        let currendIden = this.getUniqIden()
        this.existIden.push(currendIden)
        let newObj = _.cloneDeep(this.selfHandleModel)
        newObj.iden = currendIden
        this.selfHandle.push(newObj)
      },
      deleteSelfHandle(index) {
        this.selfHandle.splice(index, 1)
      },
      getUniqIden() {
        let exist = false
        _(this.existIden).forEach((res) => {
          if (res == `btn_${this.currendIden}`) {
            this.currendIden++
            exist = true
            return
          }
        })
        if (exist) {
          return this.getUniqIden()
        }
        return `btn_${this.currendIden}`
      },
      sortUp(index) {
        let temp = this.selfHandle[index]
        this.selfHandle.splice(index, 1)
        this.selfHandle.splice(index - 1, 0, temp)
      },
      sortDown(index) {
        let temp = this.selfHandle[index]
        this.selfHandle.splice(index, 1)
        this.selfHandle.splice(index + 1, 0, temp)
      }
    },
    created() {
      _(this.selfHandle).forEach(async (res) => {
        if (res.reality.id) {
          let fields = await this.getFields(res.reality.id)
          this.$set(this.fieldsByModelId, res.reality.id, fields)
        }
        this.existIden.push(res.iden)
      })
    },
    components: {
      ruleList,
      realityList
    },
    mixins: [http, cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// selfHandleConfig.vue?d1c4596e